
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { checkUrlExists } from '@/api/content';
import { debounce } from 'typescript-debounce-decorator';

@Component({})
export default class AddRedirectDialog extends Vue {
  @Prop({ default: false })
  value!: boolean;
  @Prop({ default: 'Are you sure?' })
  message!: string;
  @Prop({ default: 'fas fa-question-circle' })
  icon!: string;
  @Prop() url!: string;

  fromField: string | null = null;
  toField: string | null = null;
  toErrors: String[] = [];
  toRules: Function[] = [(v?: string) => !!v || "A 'to' URL is required"];
  isCheckingUrl: boolean = false;
  skipRedirect: boolean = false;

  @Watch('toField')
  @debounce(1000, { leading: false })
  async checkNewUrl(url: string) {
    this.isCheckingUrl = true;

    if (!url || url.startsWith('http')) {
      return true;
    }

    const exists: boolean = await checkUrlExists(url);

    if (exists === false) {
      this.toErrors.push("URL doesn't match any existing content");
    } else {
      this.toErrors = [];
    }

    this.isCheckingUrl = false;
  }

  close() {
    this.$emit('input', false);
    this.fromField = null;
    this.toField = null;
    this.skipRedirect = false;
  }

  onAdd() {
    if (this.skipRedirect) {
      this.$emit('confirm');
    } else {
      this.$emit('confirm', this.toField);
    }
    this.close();
  }

  @Watch('skipRedirect')
  onSkipRedirect(val: boolean) {
    if (val) {
      this.toErrors = [];
    } else if (this.toField) {
      // Trigger validation of toField to prevent submission of invalid URL
      this.checkNewUrl(this.toField);
    }
  }
}
